// App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider } from "./module_roots/AuthContext";
import PrivateRoute from "./module_roots/PrivateRoute";

// IMPORT UNIFIED DASHBOARD
import DashboardBusinessManager from "./module_roots/DashboardBusinessManager";

// NORMAL IMPORTS - KEPT FOR BACKWARD COMPATIBILITY
import Login from "./module_roots/Login";
import DashboardSuperAdmin from "./module_superadmin/Dashboard/Dashboard_SuperAdmin";
import LedgerView from "./module_cosmetics/LedgerView";
import SellList from "./module_fabrics/Fab_SaleList";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* ===== LOGIN ROUTES ===== */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          
          {/* ===== LEDGER VIEW ===== */}
          <Route path="/ledger" element={<LedgerView />} />
          
          {/* ===== SUPER ADMIN DASHBOARD - KEPT SEPARATE ===== */}
          <Route
            path="/DashboardSuperAdmin"
            element={
              <PrivateRoute requiredRole="super_admin">
                <DashboardSuperAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardSuperAdmin/*"
            element={
              <PrivateRoute requiredRole="super_admin">
                <DashboardSuperAdmin />
              </PrivateRoute>
            }
          />

          {/* ===== UNIFIED DASHBOARD - ALL BUSINESS ROLES ===== */}
          <Route
            path="/Dashboard-Business-Manager/*"
            element={
              <PrivateRoute>
                <DashboardBusinessManager />
              </PrivateRoute>
            }
          />

          {/* ===== LEGACY DASHBOARD REDIRECTS ===== */}
          {/* All old dashboard routes redirect to unified dashboard */}
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />
          <Route element={<Navigate to="/Dashboard-Business-Manager" replace />} />

          {/* ===== FABRICS REDIRECTIONS ===== */}
          <Route
            path="/dashboard/fab-sales"
            element={
              <PrivateRoute>
                <SellList />
              </PrivateRoute>
            }
          />

          {/* ===== LEGACY FALLBACK ===== */}
          <Route
            path="/Dashboard/*"
            element={<Navigate to="/dashboard" replace />}
          />

          {/* ===== CATCH ALL - REDIRECT TO LOGIN ===== */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;